import {createSlice} from '@reduxjs/toolkit'

export const addToSavedProspectSlice = createSlice({
  name: 'addToSavedProspect',
  initialState: {
    savedProspectsList: []
  },
  reducers: {
    setAddToSavedProspects: (state, action) => {
      state.savedProspectsList = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {setAddToSavedProspects} = addToSavedProspectSlice.actions

export default addToSavedProspectSlice.reducer
